import { FILE_TYPES } from "../../revampPages/EventInfo/config/constants";

export const validateFileCount = (currentCount, newFilesCount, maxFiles) => {
    if (currentCount + newFilesCount > maxFiles) {
        return `Maximum ${maxFiles} files allowed`;
    }
    return null;
};

export const validateFileType = (file, acceptedFileTypes) => {
    if (file.type === FILE_TYPES.SVG) {
        return `SVG file type is not supported.`;
    }
    const isValid = acceptedFileTypes.some((type) => {
        if (type === 'image/*') return file.type.startsWith('image/');
        return file.type === type;
    });
    if (!isValid) {
        return `Invalid file type: ${file.type}`;
    }
    return null;
};

export const validateFileSize = (file, maxFileSizeMB) => {
    if (file.size > maxFileSizeMB * 1024 * 1024) {
        return `File too large: ${file.name}`;
    }
    return null;
};

export const validateFile = (file, acceptedFileTypes, maxFileSizeMB) => {
    let error = validateFileType(file, acceptedFileTypes);
    if (error) return error;
    error = validateFileSize(file, maxFileSizeMB);
    if (error) return error;
    return null;
};
